import ApiWrapper from "../../../utils/ApiWrapper";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {IDashboardDto} from "../../../types/DTO/IDashboardDto";


export const fetchDashboard = createAsyncThunk<IDashboardDto>("dashboard", async () => {
    const response = await ApiWrapper.request<IDashboardDto>("/dashboard", "GET", );
    return response;
});
